import React from 'react';
import PropTypes from 'prop-types';
import { VerificationStatusStyled } from './VerificationStatusStyled';

const VerificationStatus = (props) => {
  return (
    <VerificationStatusStyled className={[props?.classStatus, props?.withoutIcon ? 'noIcon' : '', props?.isPopup? 'mr' : ''].join(' ')}>
      <div className={`verification-status ${props?.status}`}>{props?.label}</div>
    </VerificationStatusStyled>
  );
};

VerificationStatus.propTypes = {
  label: PropTypes.string,
  status: PropTypes.string,
  classStatus: PropTypes.string,
  withoutIcon: PropTypes.bool,
  isPopup: PropTypes.bool,
};

VerificationStatus.defaultProps = {
  label: 'Verification Pending',
  status: 'incomplete',
  withoutIcon: false,
  isPopup: false
};

export default VerificationStatus;
